var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "confSaveIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 394",
    transform: "translate(1495 46)",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h36v36H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "confSaveIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 484",
    fill: "none",
    d: "M0 0h36v36H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "SaveIcon",
    transform: "translate(-1495 -46)",
    clipPath: "url(#confSaveIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "SaveIcon",
    transform: "translate(1495 46)",
    clipPath: "url(#confSaveIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 442",
    fill: "#040000"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 846",
    d: "M23.273 27.727H12.726a.879.879 0 100 1.758h10.547a.879.879 0 100-1.758"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 847",
    d: "M23.273 20.7H12.726a.879.879 0 100 1.758h10.547a.879.879 0 100-1.758"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 848",
    d: "M23.273 24.211H12.726a.879.879 0 100 1.758h10.547a.879.879 0 100-1.758"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 483",
    d: "M10.09 3h12.305v7.617H10.09z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 849",
    d: "M32.743 7.945l-4.688-4.688A.88.88 0 0027.434 3h-3.282v8.5a.879.879 0 01-.879.879H9.211a.879.879 0 01-.879-.879V3H3.879A.879.879 0 003 3.879v28.242a.879.879 0 00.879.879h28.242a.879.879 0 00.879-.879V8.566a.88.88 0 00-.257-.621m-6.833 23.3H10.09v-12.3h15.82z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfSaveIcon);
export default __webpack_public_path__ + "static/media/confSaveIcon.de237f76f299a4aa.svg";
export { ForwardRef as ReactComponent };